import React, { FC } from 'react'

interface SaaSDevKeyFeaturesProps {
    saasSoftwareData: any
}

const SaaSDevKeyFeatures: FC<SaaSDevKeyFeaturesProps> = ({ saasSoftwareData }) => {
    return (
        <div className=''>
            <div className='mt-20 relative px-24 overflow-x-clip grid grid-cols-3 gap-8'>
                {saasSoftwareData.SaaSSoftwareFeatureList.map((service: any, idx: number) => {
                    return (
                        <div className={`border border-darkGreyPrimary bg-blackDark rounded-2xl p-8 bg-gradient-to-br from-transparent via-transparent to-[${service.arrowColor}]`}>
                            <div className='font-bold text-xl pb-4 flex gap-2 border-b border-darkGreyPrimary'>
                                <div>{service.title}</div></div>
                            <ul className='list-disc gap-2 flex flex-col mt-4'>
                                {service.list.map((serv: any, idx: number) => {
                                    return (
                                        <li className='text-[#E0E0E0] ml-6'>{serv.title}</li>
                                    )
                                })}
                            </ul>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default SaaSDevKeyFeatures
